<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5" >
              <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/gin/indexcon"> Manage Consignment GIN  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ alldata.SI_issueNum }} </h6>
  
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->
  
  
  
  
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              
                    <button  @click="Confimmodel()" v-if="alldata.SI_status==1"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                    <button  @click="Createinvoice()" v-if="alldata.SI_status==3"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Create Invoice</button>
                  
  
                  <button  @click="Update()" v-if="alldata.SI_status==1"   class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="alldata.SI_status!=1"  @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                 
            
                </div>
  
  
  
  
  
                <div class="card custom_bdr_rds">
                <div style="background-color: #f2f3f4; " class="card-body custom_bdr_rds">
  
  
                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Issue No. </b></td>
                           <td>{{ alldata.SI_issueNum }}</td> 
                          </tr>
                          <tr>
                            <td><b>Issued Date</b></td>
                           <td>{{ alldata.issues_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Type</b></td>
                           <td>{{ alldata.SI_type }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Sales Order</b></td>
                           <td>{{ alldata.relatedToSo.so_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date </b></td>
                           <td>{{ alldata.SI_created_date }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Customer </b></td>
                           <td>{{ alldata.relatedToCustomer.C_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Delivery Address </b></td>
                           <td>{{ alldata.relatedToCustomerAdd.address_line_1 }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Person </b></td>
                           <td>{{ alldata.relatedToSalesPerson.name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Payment Method </b></td>
                           <td>{{ alldata.relatedToSo.payment_method }}</td> 
                          </tr>
                          <tr>
                            <td><b>Remarks </b></td>
                           <td>{{ alldata.SI_remarks }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ alldata.relatedToStatus.status }}</td> 
                          </tr>
  
  
                          <tr>
                              <td><b>Quotation Code</b></td>
                             <td>{{ all_code.qu_code }}</td> 
                            </tr>
                           
                            <tr>
                              <td><b> SO Code</b></td>
                              <td>{{ all_code.so_code }}</td> 
                            </tr>
                            <tr>
                              <td><b>Invoice Number</b></td>
                              <td>{{ all_code.invoice_num }}</td> 
                            </tr>
                            <tr>
                              <td><b>Receipt Number</b></td>
                              <td>{{ all_code.rec }}</td> 
                            </tr>
                            
                          
                          
                          
                         
                           
                        </tbody>
                 
                 
                      </table>
  
  
  
                      <div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>GIN Item List</b></h6>
  
                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead style="border-bottom: 2px solid black; ">
                              <tr>
                              <th>#</th>
                              <th>Product Code</th>
                              <th>Product Description</th>
                          
                              <th class="text_right">Qty</th>
                              <th class="text_right">	BIN Location</th>
                              <th class="text_right">Batch No.	</th>
                              <th class="text_right">Return Qty</th>
                        
                              <th class="text_right">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td> {{ detail.p_code }}</td>
                              <td >{{detail.P_description}}</td>
                              <td class="text_right">{{ detail.qty }}</td>
                              <td class="text_right">{{ detail.bin_location }}</td>
                              <td class="text_right"></td>
                              <td class="text_right"></td>
                          
                              <td class="text_right">{{ detail.status }}</td>
                              </tr>
                              <tr style="border-top: 2px solid black; " >
                              <td></td>
                              <th>Total :</th>
                              <td></td>
                              <td class="text_right">{{ total.total_qty }}</td>
                              <td></td>
                              <th class="text_right"></th>
                              <th class="text_right"></th>
                            
                              <td class="text_right"></td>
                              </tr>
                             
                           
                            </tbody>
  
                          </table>
  
  
                        </div>
                    </div>
  
  
  
  
  
  
                    <div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>
  
                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead style="border-bottom: 2px solid black; ">
                              <tr>
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>
  
                          </table>
  
  
                        </div>
                    </div>
  
  
  
                    <div class="card custom_bdr_rds">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>
  
                  
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead style="border-bottom: 2px solid black; ">
                    <tr>
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  
                    
                    </tr>
                  </tbody>
  
                </table>
  
  
              </div>
          </div>
  
  
          <div class="card custom_bdr_rds">
            <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Add CRM Notes</b></h6>
  
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3"   style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="selectedOption">
                              <option  selected>Select....</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input   style="font-size: small;" class="form-control" >
                    </div>
                  </div>
  
  
                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button   class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Save</button>
                </div>
                </div>
  
            </div>
        </div>
  
  
  
  
  
  
  
   
  
  <br><br>
  
  
  
  
  
                
  
  
  
  
                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
        import jsPDF from 'jspdf';
     import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {
  
        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            total:{},
            alldata:{},
            category:{},
            brand:{},
            supplier:{},
            all_code:{},
            status:{},
            user:{},
            details:[],
            trans:[],
     
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },
  
        methods : {
  
          generatePDF() {
      
      const doc = new jsPDF();
  
      function addPageBorders(doc) {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
  
    // Set the border style
    doc.setDrawColor(71, 144, 255); // Black color
    doc.setLineWidth(15); // Border width
  
    // Draw a line at the top of the page
    doc.line(0, 0, pageWidth, 0);
    // Draw a line at the bottom of the page
    doc.line(0, pageHeight, pageWidth, pageHeight);
  }
     // Update this with your image URL or file path
   
      var img = new Image()
    img.src = '/img/evenware-logo.png'
    const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
  const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed
  
  doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
  doc.setFontSize(18);
  doc.setFont('Helvetica', 'bold');
  doc.text('Consignment GIN', 105, 30, null, null, 'center');
  doc.setFontSize(12);
  
  doc.text('Demonstration System', 10, 45, null, null);
  
  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
  doc.text('Nawala Road,', 10, 51, null, null);
  doc.text('Rajagiriya,', 10, 54, null, null);
  doc.text('Colombo 08,', 10, 57, null, null);
  doc.text('Sri Lanka', 10, 60, null, null);
  doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
  doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);
  
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('GIN To:', 85, 45, null, null);
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.alldata.relatedToCustomer.C_name, 85, 48, null, null);
  doc.text(this.alldata.relatedToCustomer.C_address_line1, 85, 51, null, null);
  doc.text(this.alldata.relatedToCustomer.C_address_line2, 85, 54, null, null);
  doc.text(this.alldata.relatedToCustomer.C_address_line3, 85, 57, null, null);
  
  
  
  
  
  
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('GIN No:', 200, 45, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.alldata.SI_issueNum, 200, 49, null, null, 'right');
  
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('SO Code:', 200, 53, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.alldata.relatedToSo.so_code, 200, 56, null, null, 'right');
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Sales Person:', 200, 60, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.alldata.relatedToSalesPerson.name, 200, 63, null, null, 'right');
  
  
  
  
  
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Date:', 200, 67, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.alldata.issues_date, 200, 70, null, null, 'right');
  
  const tableData = [
        ['No', 'Product Code', 'Product Description',  'Qty', 'Bin Location']
    ];
    
  
    this.details.forEach(detail => {
        tableData.push([
            detail.no,
            detail.p_code,
            detail.P_description,
          
            { content: detail.qty, styles: { halign: 'right' } },
            detail.bin_location,
           
         
           
           
           
          
        ]);
    });
  
        // Add table to the PDF
        doc.autoTable({
              startY: 85, // Y position to start the table
              head: [tableData[0]], // Table header
              body: tableData.slice(1),
              addPageContent: function(data) {
          addPageBorders(doc); // Call the function to add page borders
      },
      styles: {
          font: 'Helvetica',
          fontSize:8,
      },
            // Table data excluding header
        });
  
        
        const tableBottomY = doc.lastAutoTable.finalY;
  
        doc.setFontSize(10);
        doc.setFont('Helvetica', 'bold');
        doc.text('Sub Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');
  
        doc.setFontSize(10);
        doc.setFont('Helvetica', 'bold');
        doc.text('Special Discount: '+this.total.special_discount, 195, tableBottomY+18, null, null, 'right');
  
        doc.setFontSize(10);
        doc.setFont('Helvetica', 'bold');
        doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');
  
        doc.setFontSize(9);
          doc.setFont('Helvetica', 'normal');
        doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+50, null, null);
        doc.text('* Settlement should be made within 5 days', 10, tableBottomY+55, null, null);
        doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+60, null, null);
        doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+65, null, null);
        doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+70, null, null);
        doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+75, null, null);
        
  
  
        doc.output('dataurlnewwindow');
  
    },
          
          async Update(){
        this.$router.push('/gin/update?id='+this.id);
      },

      async Createinvoice(id){
        this.$router.push('/sinvoice/createsoinvoicecon?id='+this.id);
      },
  
            async loadSquatation() {
     
      
      try {
        const { data} = await  axios.get('/istockissue/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.alldata = data.alldata
         this.all_code = data.all_code
          this.details = data.details
          this.total = data.total
       
        
      } catch (error) {
        console.log(error.response);
      }
    },
  
  
  
        
  
  
  
    },
    
    }
    
    </script>
  
    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
  /* .vs__dropdown-option--disabled {
    display: block;
  } */
  
  .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
  
  
  
  cursor: pointer;
  }
  
  .button-link:hover {
  color: black;
  text-decoration: underline;
  }
    </style>